import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import LineLogin from "../sso/line-login";
import { ENGAGE_GET_CREDIT_SESSION } from "../../../../constants";

interface LoginContext {
    subcampaignId: string;
    qrscanlogId: string;
    channelSessionId: string;
    engageGetCreditSession: string;
    originalUrl: string;
    login_method: string;
    merchantReference: string;
    advertiserLogo: string;
}

const LineLiffAuth = () => {
    const location = useLocation();
    const initialized = useRef(false);

    useEffect(() => {
        if (initialized.current) {
            return;
        }
        initialized.current = true;

        const handleAuthRedirect = () => {

            let context: LoginContext | null = null;

            try {
                // Extract parameters from URL
                const urlParams = new URLSearchParams(location.search);
                const liffState = urlParams.get("liff.state");
                console.log("liffState-log", liffState);

                if (liffState) {
                    const decoded = decodeURIComponent(liffState);
                    const params = new URLSearchParams(decoded.startsWith("?") ? decoded.slice(1) : decoded);

                    context = {
                        subcampaignId: params.get("subcampaign_id") || "",
                        qrscanlogId: params.get("qrscanlog_id") || "",
                        channelSessionId: params.get("channel_session_id") || "",
                        engageGetCreditSession: params.get("engage_get_credit_session") || "",
                        originalUrl: params.get("original_url") || "",
                        login_method: params.get("login_method") || "",
                        merchantReference: params.get("merchant_reference") || "",
                        advertiserLogo: params.get("advertiser_logo") || "",
                    };
                    localStorage.setItem("LIFF_LOGIN_CONTEXT", JSON.stringify(context));

                } else if (urlParams.get("login_method")) {

                    context = {
                        subcampaignId: urlParams.get("subcampaign_id") || "",
                        qrscanlogId: urlParams.get("qrscanlog_id") || "",
                        channelSessionId: urlParams.get("channel_session_id") || "",
                        engageGetCreditSession: urlParams.get("engage_get_credit_session") || "",
                        originalUrl: urlParams.get("original_url") || "",
                        login_method: urlParams.get("login_method") || "",
                        merchantReference: urlParams.get("merchant_reference") || "",
                        advertiserLogo: urlParams.get("advertiser_logo") || "",
                    };
                    localStorage.setItem("LIFF_LOGIN_CONTEXT", JSON.stringify(context));
                } else {
                    const saved = localStorage.getItem("LIFF_LOGIN_CONTEXT");
                    if (saved) {
                        context = JSON.parse(saved);
                    }
                }

                const {
                    subcampaignId = "",
                    qrscanlogId = "",
                    channelSessionId = "",
                    engageGetCreditSession = "",
                    originalUrl = "",
                    login_method = "",
                    merchantReference = "",
                    advertiserLogo = "",
                } = context || {};


                localStorage.setItem("subcampaign_id", subcampaignId);
                localStorage.setItem("qrscanlog_id", qrscanlogId);
                localStorage.setItem("channel_session_id", channelSessionId);
                localStorage.setItem(ENGAGE_GET_CREDIT_SESSION, engageGetCreditSession);
                localStorage.setItem("merchant_reference", merchantReference);
                localStorage.setItem("login_method", login_method);
                localStorage.setItem("advertiser_logo", advertiserLogo);

                const lineLogin = new LineLogin(login_method);
                const ssoUrl = lineLogin.auth();
                window.location.href = ssoUrl;

            } catch (error) {
                console.error("Auth redirect error:", error);
                window.location.href = "/login";
            }
        };

        handleAuthRedirect();
    }, [location.search]);

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            flexDirection: "column"
        }}>
            <div>Processing LINE Login...</div>
            <div style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}>
                Please wait while we complete authentication.
            </div>
        </div>
    );
};

export default LineLiffAuth;
